import { render, staticRenderFns } from "./DesignTableColumn.vue?vue&type=template&id=bd85af84&scoped=true&"
import script from "./DesignTableColumn.vue?vue&type=script&lang=js&"
export * from "./DesignTableColumn.vue?vue&type=script&lang=js&"
import style0 from "./DesignTableColumn.vue?vue&type=style&index=0&id=bd85af84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd85af84",
  null
  
)

export default component.exports